import { Component } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import TagManager from 'react-gtm-module';
import Can, { checkPermission } from '../common/guards/can';
import { USER_TYPE_ADMIN, USER_TYPE_REP, USER_TYPE_RETAILER, USER_TYPE_PRE_LOGIN } from '../../data/userTypes';
import UnreadMessages from './unread-messages';
import EditButton from './edit-button';
import PseudoLoginButton from './pseudo-login-button';
import { isPseudoLoggedIn } from '../../utils/tokenUtils';

import './user-menu.css';

const myProfile = (
  <Dropdown.Item eventKey="1" href="/my-profile">
    My Profile
  </Dropdown.Item>
);
const myMessages = (
  <Dropdown.Item eventKey="2" href="/my-messages">
    My Messages
  </Dropdown.Item>
);
const updatePassword = (
  <Dropdown.Item eventKey="3" href="/update-password">
    Update Password
  </Dropdown.Item>
);
const pointsStatement = (
  <Dropdown.Item eventKey="5" href="/points-statement">
    Points Statement
  </Dropdown.Item>
);
const logout = (
  <Dropdown.Item eventKey="6" href="/logout">
    Logout
  </Dropdown.Item>
);

const adminMyProfile = (
  <Dropdown.Item eventKey="11" href="/admin/my-profile">
    My Profile
  </Dropdown.Item>
);
const adminUpdatePassword = (
  <Dropdown.Item eventKey="12" href="/admin/update-password">
    Update Password
  </Dropdown.Item>
);
const adminUpdateSecurityQuestion = (
  <Dropdown.Item eventKey="13" href="/admin/update-security-questions">
    Update Security Questions
  </Dropdown.Item>
);
const adminLogout = (
  <Dropdown.Item eventKey="15" href="/admin/logout">
    Logout
  </Dropdown.Item>
);

const repMyProfile = (
  <Dropdown.Item eventKey="11" href="/team/my-profile">
    My Profile
  </Dropdown.Item>
);
const repUpdatePassword = (
  <Dropdown.Item eventKey="12" href="/team/update-password">
    Update Password
  </Dropdown.Item>
);
const repUpdateSecurityQuestion = (
  <Dropdown.Item eventKey="13" href="/team/update-security-questions">
    Update Security Questions
  </Dropdown.Item>
);
const repLogout = (
  <Dropdown.Item eventKey="15" href="/team/logout">
    Logout
  </Dropdown.Item>
);
const repMyMessages = (
  <Dropdown.Item eventKey="14" href="/team/my-messages">
    My Messages
  </Dropdown.Item>
);
const preLoginButtons = (
  <div>
    <Button variant="default" className="home-register-button" href="/registration/outlet">
      REGISTER
    </Button>
    <Button variant="default" className="home-login-button" href="/login">
      <span className="glyphicon glyphicon-user"></span>
      LOGIN
    </Button>
  </div>
);

class UserMenu extends Component {
  showProfile = () => {
    const {type} = this.props;
    if (type === USER_TYPE_ADMIN) {
      return adminMyProfile;
    }
    if (type === USER_TYPE_REP) {
      return repMyProfile;
    }
    if (type === USER_TYPE_PRE_LOGIN) {
      return null;
    }
    return myProfile;
  };

  showMyMessages = () => {
    const {type} = this.props;
    if (type === USER_TYPE_RETAILER) {
      return checkPermission('view', 'web_app_messages') ? myMessages : null;
    }
    if (type === USER_TYPE_REP) {
      return checkPermission('view', 'messages_rep_area') ? repMyMessages : null;
    }
    return null;
  };

  showUpdatePassword = () => {
    const {type} = this.props;
    if (checkPermission('update', 'personal_info')) {
      if (type === USER_TYPE_ADMIN) {
        return adminUpdatePassword;
      }
      if (type === USER_TYPE_REP) {
        return repUpdatePassword;
      }
      return updatePassword;
    }

    return null;
  };

  showUpdateSecurityQuestions = () => {
    const {type} = this.props;
    if (checkPermission('update', 'personal_info')) {
      if (type === USER_TYPE_ADMIN) {
        return adminUpdateSecurityQuestion;
      }
      if (type === USER_TYPE_REP) {
        return repUpdateSecurityQuestion;
      }
    }

    return null;
  };

  showPointsStatement = () => {
    const {user, type} = this.props;
    if (!checkPermission('view', 'web_app_points')) {
      return null;
    }
    return (user.attributes['has-reward-outlet'] && type === USER_TYPE_RETAILER) && pointsStatement;
  };

  showLogout = () => {
    const {type} = this.props;
    if (type === USER_TYPE_ADMIN) {
      return adminLogout;
    }
    if (type === USER_TYPE_REP) {
      return repLogout;
    }
    if (type === USER_TYPE_PRE_LOGIN) {
      return null;
    }
    return logout;
  };

  showEditPageButton = () => {
    const {type} = this.props;
    return type !== USER_TYPE_ADMIN || window.location.href.match('/admin/news/edit-content') !== null;
  }

  links = () => preLoginButtons;

  editContent = () => {
    this.props.dispatch({type: 'TOGGLE_EDIT_CONTENT'});
  };

  myMessagesUrl = () => {
    const {type} = this.props;
    if (type === USER_TYPE_RETAILER) {
      return '/my-messages';
    }
    if (type === USER_TYPE_REP) {
      return '/team/my-messages';
    }
    return null;
  };

  componentDidMount() {
    const mode = this.props.isPseudoLogin ? 'demo_mode' : 'standard_mode';
    TagManager.dataLayer({
      dataLayer: {
        viewMode: mode
      }
    });
  }

  render() {
    const {
      type, user, unreadMessages, isPseudoLogin
    } = this.props;

    const messageIconPermissions = {
      [USER_TYPE_RETAILER]: 'web_app_messages',
      [USER_TYPE_REP]: 'messages_rep_area,'
    };

    return (
      <div id="user-panel-wrap">
        <div className="user-panel">
          {isPseudoLogin && <PseudoLoginButton/>}
          { type === 'pre_login' ? this.links() : null}
          { type !== 'pre_login' ? (
            <div>
              <Can action="view" subjectClass={messageIconPermissions[type] || messageIconPermissions[USER_TYPE_REP]}>
                <UnreadMessages
                  unreadMessages={unreadMessages}
                  show={type !== USER_TYPE_ADMIN}
                  url={this.myMessagesUrl()}
                />
              </Can>
              <Dropdown>
                <Dropdown.Toggle variant="primary" id="userdopdown">
                  {`${user.attributes['first-name']} ${user.attributes['last-name']}`}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {this.showProfile()}
                  {this.showMyMessages()}
                  {this.showUpdatePassword()}
                  {this.showUpdateSecurityQuestions()}
                  <Dropdown.Divider/>
                  {this.showPointsStatement()}
                  {this.showLogout()}
                </Dropdown.Menu>
              </Dropdown>

              <EditButton
                show={this.showEditPageButton()}
                onClick={this.editContent}
              />
            </div>
          ) : null}
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  viewConfig: state.viewConfig,
  user: state.viewConfig.profile,
  isPseudoLogin: isPseudoLoggedIn(),
  unreadMessages: state.messages.unreadMessagesCount
});

export default connect(mapStateToProps)(UserMenu);
